import React, { Fragment } from 'react'

import { isEmpty } from 'ramda'

import { Button, H1 } from '@driftt/tide-core'

import PasswordInput from 'components/PasswordInput'
import { meetsAllRequirements } from 'utils/password'

import './style.css'

const canSubmit = (
  password,
  config,
  passwordConfigFetched,
  missingPasswordConfig
) => {
  if (passwordConfigFetched && !missingPasswordConfig) {
    return meetsAllRequirements(password, config)
  } else {
    return !!password
  }
}

const showWarning = (password, config, passwordUpdateStatus) => {
  return (
    passwordUpdateStatus === 'failed' && !meetsAllRequirements(password, config)
  )
}

export const BasicPasswordStep = ({
  password,
  onPasswordChange,
  onContinueClick,
  passwordConfig,
  passwordConfigFetched,
  passwordUpdateStatus,
}) => {
  const missingPasswordConfig = passwordConfigFetched && isEmpty(passwordConfig)
  const continueDisabled = !canSubmit(
    password,
    passwordConfig,
    passwordConfigFetched,
    missingPasswordConfig
  )
  const passwordPending = passwordUpdateStatus === 'pending'
  return (
    <Fragment>
      <H1 className="password-step-header">Activate your Drift account</H1>
      <PasswordInput
        value={password}
        passwordConfig={passwordConfig}
        passwordConfigFetched={passwordConfigFetched}
        passwordUpdateStatus={passwordUpdateStatus}
        onChange={onPasswordChange}
      />
      {!passwordConfigFetched || missingPasswordConfig ? (
        <Button
          className="no-password-hints-button"
          onClick={onContinueClick}
          disabled={continueDisabled}
          loading={passwordPending}
        >
          Activate account
        </Button>
      ) : (
        <Button
          onClick={onContinueClick}
          disabled={continueDisabled}
          loading={passwordPending}
        >
          Next
        </Button>
      )}
      {missingPasswordConfig ? (
        <strong className="reset-password-error">
          We couldn't find your organization's password requirements. Please try
          again!
        </strong>
      ) : (
        showWarning(password, passwordConfig, passwordUpdateStatus) && (
          <strong className="reset-password-error">
            Your password is almost secure! Make sure that you meet all
            requirements.
          </strong>
        )
      )}
    </Fragment>
  )
}

export const PasswordStep = ({
  password,
  onPasswordChange,
  onContinueClick,
  passwordConfig,
  passwordConfigFetched,
  passwordUpdateStatus,
}) => {
  const missingPasswordConfig = passwordConfigFetched && isEmpty(passwordConfig)
  const continueDisabled = !canSubmit(
    password,
    passwordConfig,
    passwordConfigFetched,
    missingPasswordConfig
  )
  const passwordPending = passwordUpdateStatus === 'pending'
  return (
    <Fragment>
      <h1>Set a Password</h1>
      <PasswordInput
        value={password}
        passwordConfig={passwordConfig}
        passwordConfigFetched={passwordConfigFetched}
        passwordUpdateStatus={passwordUpdateStatus}
        onChange={onPasswordChange}
      />
      {!passwordConfigFetched || missingPasswordConfig ? (
        <Button
          className="no-password-hints-button"
          onClick={onContinueClick}
          disabled={continueDisabled}
          loading={passwordPending}
        >
          Next
        </Button>
      ) : (
        <Button
          onClick={onContinueClick}
          disabled={continueDisabled}
          loading={passwordPending}
        >
          Next
        </Button>
      )}
      {missingPasswordConfig ? (
        <strong className="reset-password-error">
          We couldn't find your organization's password requirements. Please try
          again!
        </strong>
      ) : (
        showWarning(password, passwordConfig, passwordUpdateStatus) && (
          <strong className="reset-password-error">
            Your password is almost secure! Make sure that you meet all
            requirements.
          </strong>
        )
      )}
    </Fragment>
  )
}

export const AEPasswordStep = ({
  password,
  onPasswordChange,
  onContinueClick,
  passwordConfig,
  passwordConfigFetched,
  passwordUpdateStatus,
}) => {
  const missingPasswordConfig = passwordConfigFetched && isEmpty(passwordConfig)
  const passwordPending = passwordUpdateStatus === 'pending'
  return (
    <Fragment>
      <h1>Activate your Drift Account</h1>
      <p>Just set your password!</p>
      <PasswordInput
        value={password}
        passwordConfig={passwordConfig}
        passwordConfigFetched={passwordConfigFetched}
        passwordUpdateStatus={passwordUpdateStatus}
        onContinueClick={onContinueClick}
        onChange={onPasswordChange}
        configurableReqs={true}
      />
      {!passwordConfigFetched || missingPasswordConfig ? (
        <Button
          className="no-password-hints-button"
          onClick={onContinueClick}
          disabled={!canSubmit(password, passwordConfig, passwordConfigFetched)}
          loading={passwordPending}
        >
          Activate account
        </Button>
      ) : (
        <Button
          onClick={onContinueClick}
          disabled={!canSubmit(password, passwordConfig, passwordConfigFetched)}
          loading={passwordPending}
        >
          Activate account
        </Button>
      )}
      {missingPasswordConfig ? (
        <strong className="reset-password-error">
          We couldn't find your organization's password requirements. Please try
          again!
        </strong>
      ) : (
        showWarning(password, passwordConfig, passwordUpdateStatus) && (
          <strong className="reset-password-error">
            Your password is almost secure! Make sure that you meet all
            requirements.
          </strong>
        )
      )}
    </Fragment>
  )
}
